import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { HelperService } from '@services/helper/helper.service';

@Pipe({
    name: 'contentRestaurant',
    standalone: false
})
export class RestaurantPipe implements PipeTransform {
  constructor(private contentPipeService: ContentPipeService) {
  }

  private static removeLeadingBr(string = ''): string {
    string = !!string ? string : '';
    while (string.trim().startsWith('<br>') || string.trim().startsWith('<br/>') || string.trim().startsWith('<br />')) {
      if (string.trim().startsWith('<br>')) {
        string = string.replace('<br>', '');
      } else if (string.trim().startsWith('<br/>')) {
        string = string.replace('<br/>', '');
      } else if (string.trim().startsWith('<br />')) {
        string = string.replace('<br />', '');
      }
    }
    return string;
  }

  private static enhanceRestaurantDetail(restaurantContent, data) {
    restaurantContent.subtitle = data.subtitle;
    restaurantContent.teaser = RestaurantPipe.removeLeadingBr(data.introduction || data.textContent);
    restaurantContent.description = RestaurantPipe.removeLeadingBr(data.textContent);
    if (data?.openingHours?.regularOpeningHours) {
      let useOpeningHours = false;
      if (data.openingHours.exceptionDays && data.openingHours.exceptionDays.length) {
        useOpeningHours = true;
      }
      for (const key of Object.keys(data.openingHours.regularOpeningHours)) {
        if (data.openingHours.regularOpeningHours[key].open) {
          useOpeningHours = true;
        }
      }
      if (useOpeningHours) {
        restaurantContent.openingHours = data.openingHours;
      }
    }

    restaurantContent.openingHours = HelperService.initOpeningData(data) || data.openingHours;
    if (!!data?.openingHours?.disabled) {
      delete restaurantContent.openingHours;
    }
    restaurantContent.seasonTimes = data.seasonTimes;
    restaurantContent.website = data.website;
    restaurantContent.categories = data.categories;
    if (data.location) {
      restaurantContent.street = data.location.address;
      restaurantContent.city = data.location.city;
      restaurantContent.zip = data.location.zip;
      if (data.location.coordinates) {
        restaurantContent.latitude = data.location.coordinates.latitude;
        restaurantContent.longitude = data.location.coordinates.longitude;
      }
    }
    if (data.bookable && data.bookingUrl) {
      restaurantContent.bookable = data.bookable;
      restaurantContent.bookingUrl = data.bookingUrl;
      restaurantContent.bookingText = data.bookingText;
    }
    if (data.contact && data.contact.length) {
      for (const contactVariant of data.contact) {
        if (contactVariant.type === 'phone') {
          restaurantContent.phone = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          restaurantContent.fax = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          restaurantContent.email = contactVariant.value;
        }
      }
    }

    return HelperService.setEmptyStringsToNull(restaurantContent)
  }

  transform(entry: any): Models.RestaurantEntry | Models.RestaurantEntry[] {
    if (!entry) {
      return null;
    }

    /* detail */
    if (!entry || !entry.content) {
      return null;
    }
    const restaurant: any = new Models.RestaurantEntry();

    let media = this.contentPipeService.getMedia(entry);
    const documents = this.contentPipeService.getDocuments(entry);

    media = _.orderBy(media, ['type'], ['asc']);

    let restaurantContent = { sourceId: entry._id, title: entry.title.trim(), media, documents };

    if (entry.content) {
      restaurantContent = RestaurantPipe.enhanceRestaurantDetail(restaurantContent, entry.content);
    }

    restaurant.populateFromJSON(restaurantContent);
    restaurant.contentType = 'restaurant';
    return restaurant;
  }
}
